import { useState } from "react";
import { BsFillCaretDownFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
type PropsType = {};
const Language: React.FC<PropsType> = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { t, i18n } = useTranslation();
  const router = useRouter();

  return (
    <div
      className="relative select-none"
      style={{
        fontFamily: `${i18n.language === "en" ? "Baloo-regular" : "Almarai"}`,
      }}
    >
      <div
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center cursor-pointer "
      >
        <p className="text-[18px] font-bold text-white">{t("Resources")}</p>
        <BsFillCaretDownFill className="mx-2 text-white" />
      </div>
      <div
        className={`${
          showMenu ? "" : "hidden"
        } absolute z-20    top-8   text-center`}
      >
        <p
          className="py-1 text-lg font-semibold text-white cursor-pointer "
          onClick={() => {
            router.push("/Agri-Tech/blogs");
            setShowMenu(false);
          }}
        >
          {t("Blogs")}
        </p>
        <p
          className="py-1 text-lg font-semibold text-white cursor-pointer "
          onClick={() => {
            router.push("/Agri-Tech/FAQ");
            setShowMenu(false);
          }}
        >
          {t("FAQ")}
        </p>
      </div>
    </div>
  );
};
export default Language;
